<div class="inbox-page">
  <div class="inbox-header">
    <div>
      <h1>Export requests</h1>
      <p>Requests to notarise traced events with another company.</p>
    </div>
    <button mat-flat-button class="btn-submit" (click)="openRaiseDialog()">
      <mat-icon>add</mat-icon>
      New export request
    </button>
  </div>

  <div class="count-card count-card--blue">
    <div class="count-card__icon"><span class="material-icons">swap_horiz</span></div>
    <div class="count-card__text">
      <span class="count-card__main"><strong>{{ totalCount() }}</strong> Requests</span>
      <span class="count-card__status">{{ directionLabel }} · {{ statusFilterLabel }}</span>
    </div>
  </div>

  <div class="toolbar">
    <div class="tabs">
      <button [class.active]="direction() === 'incoming'" (click)="setDirection('incoming')">Incoming</button>
      <button [class.active]="direction() === 'outgoing'" (click)="setDirection('outgoing')">Outgoing</button>
    </div>

    <app-filter-select
      [(ngModel)]="statusFilter"
      name="statusFilter"
      (ngModelChange)="onFilterChange()"
      [options]="statusOptions"
      allLabel="All statuses"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (requests().length === 0) {
    <app-empty-state [message]="'No ' + direction() + ' export requests.'" />
  } @else {
    <table>
      <thead>
        <tr>
          <th>{{ direction() === 'incoming' ? 'From' : 'To' }}</th>
          <th>EPC</th>
          <th>Events</th>
          <th>Status</th>
          <th>Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (request of requests(); track request.id) {
          <tr>
            <td>
              @if (counterparty(request); as cp) {
                {{ cp.name }} <span class="country-code">({{ cp.countryCode }})</span>
              } @else {
                —
              }
            </td>
            <td><code>{{ request.epc }}</code></td>
            <td>{{ request.eventCount }}</td>
            <td><app-status-badge [status]="request.status" /></td>
            <td>{{ request.createdAt | date: 'medium' }}</td>
            <td>
              <a
                [routerLink]="['/export-requests', request.id]"
                class="view-btn"
                title="View export request"
                aria-label="View export request"
              >
                <span class="material-icons">arrow_forward</span>
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages() - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount() }} requests</span>
      </div>
    </div>
  }
</div>
